const sectionFaqGrid05Css = `
[data-type='section-faq-grid-05'] .faq-grid-container-fluid {
  padding: 40px 0;
  width: 100%;
  background-color: var(--background-container, #ffffff);
  margin: 0 auto;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid:not(:empty) {
  margin-bottom: 32px !important;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid h1,
[data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid h2,
[data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid h3 {
  font-size: 28px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid h1:last-child,
[data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid h2:last-child,
[data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid p {
  font-size: 16px;
  margin: 0 0 8px 0 !important;
  line-height: normal;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid[data-container-full-width='true'] .faq-grid-container {
  margin: 0 auto;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid[data-container-full-width='false'] .faq-grid-container {
  max-width: 766px;
  margin: 0 auto;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid[data-show-separator='true'] .list-item {
  gap: 1px;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid[data-show-line-color='true'] .list-item .item-wapper .item-question {
  padding: 16px 16px 16px 28px;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid[data-show-line-color='true'] .list-item .item-wapper .item-question-line {
  content: '';
  height: 100%;
  width: 16px;
  background-color: #3b866a;
  position: absolute;
  left: 0;
  top: 0;
}

[data-type='section-faq-grid-05'] .faq-grid-container-fluid[data-show-line-color='false'] .list-item .item-wapper .item-question-line {
  display: none;
}

[data-type='section-faq-grid-05'] .list-item {
  display: flex;
  flex-direction: column;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper {
  overflow: hidden;
  height: fit-content;
  background-color: var(--background-faq-item, #ebebeb);
  color: var(--text-faq-item-color, #000000);
}

[data-type='section-faq-grid-05'] .list-item .item-wapper .item-question {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;
  position: relative;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper .item-question .title-item-question {
  width: calc(100% - 40px);
  font-size: 16px;
  margin: 0 !important;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper .item-question span {
  display: flex;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper .item-question span svg {
  width: 16px;
  height: 16px;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] {
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  background-color: var(--background-faq-item-content, #ffffff);
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content {
  padding: 16px;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h1,
[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h2,
[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h1:last-child,
[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h2:last-child,
[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content ul {
  margin-bottom: 12px !important;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content figure {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100% !important;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100% !important;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content table p {
  margin-bottom: 8px !important;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content table img {
  width: 24px;
  height: 24px;
  object-fit: cover;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content table thead tr th {
  padding: 16px;
  text-align: left;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content table thead tr th p {
  margin-bottom: 0 !important;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content table tbody tr:nth-child(odd) {
  background-color: #ebebeb;
}

[data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content table tbody td {
  padding: 16px;
}

@container (max-width: 768px) {
  [data-type='section-faq-grid-05'] .faq-grid-container-fluid {
    padding: 16px 0;
  }

  [data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid:not(:empty) {
    margin-bottom: 24px !important;
  }

  [data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid h1,
  [data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid h2,
  [data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid h3 {
    font-size: 20px;
  }

  [data-type='section-faq-grid-05'] .faq-grid-container-fluid .title-faq-grid p {
    font-size: 14px;
  }

  [data-type='section-faq-grid-05'] .list-item .item-wapper {
    width: 100%;
  }

  [data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h1,
  [data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h2,
  [data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content table thead tr th {
    padding: 10px;
  }

  [data-type='section-faq-grid-05'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content table tbody td {
    padding: 10px;
  }
}
`;
export default sectionFaqGrid05Css;
